import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { RequestCED } from "../models/request-ced";
import { RequestSFPJ } from "../models/request-sfpj";
import { catchError, Observable, of } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ClaimsService {
  private readonly claimsUrl = "claims";
  private readonly cedEndPoint = "/ced";
  private readonly sfpjEndPoint = "/sfpj";
  private readonly digidroitEndPoint = "/digidroit";
  private readonly baseUrl: string;

  constructor(private readonly http: HttpClient) {
    this.baseUrl = environment.apiConfig.uri + this.claimsUrl;
  }

  redirectCED(referencePolicy: string | null, target: string | null): Observable<boolean> {
    const body: RequestCED = {
      referencePolicy: referencePolicy,
      target: target,
    };
    const httpParams = new HttpParams({ fromObject: body as any });

    return this.http.get(this.baseUrl + this.cedEndPoint, { params: httpParams, responseType: "text" }).pipe(
      map((response: string) => {
        if (response === null || response.trim() === "") {
          return false;
        }
        window.open(response, "_blank");
        return true;
      }),
      catchError(() => {
        return of(false);
      })
    );
  }

  redirectSFPJ(referencePolicy: string | null, page: string | null): Observable<boolean> {
    const body: RequestSFPJ = {
      referencePolicy: referencePolicy,
      page: page,
    };
    const httpParams = new HttpParams({ fromObject: body as any });
    return this.http.get(this.baseUrl + this.sfpjEndPoint, { params: httpParams, responseType: "text" }).pipe(
      map((response: string) => {
        if (response === null || response.trim() === "") {
          return false;
        }
        window.open(response, "_blank");
        return true;
      }),
      catchError(() => {
        return of(false);
      })
    );
  }

  redirectDigidroit(): Observable<boolean> {
    return this.http.get(this.baseUrl + this.digidroitEndPoint, { responseType: "text" }).pipe(
      map((response: string) => {
        if (response === null || response.trim() === "") {
          return false;
        }
        window.open(response, "_blank");
        return true;
      }),
      catchError(() => {
        return of(false);
      })
    );
  }
}
